module.exports = __webpack_public_path__ + "static/img/en4.0f7e943.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en4.jpg
// module id = ZejU
// module chunks = 1